import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
import { Feedback } from './interface';
const logger = createLogger(__filename);
const feedbackApiClient = {
  addFeedback: async (feedback: Feedback): Promise<number> => {
    const url = new URL('/app/v1/feedback', API_BASE_URL);
    logger.trace('feedbackApiClient.addFeedback()');
    return deserialize(
      await fetchWrapper(url.href, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedback),
      })
    );
  },
};
export default feedbackApiClient;
